import { render, staticRenderFns } from "./DisposeFACoalManager.vue?vue&type=template&id=27c2b3dc"
import script from "./DisposeFACoalManager.vue?vue&type=script&lang=js"
export * from "./DisposeFACoalManager.vue?vue&type=script&lang=js"
import style0 from "./DisposeFACoalManager.vue?vue&type=style&index=0&id=27c2b3dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports